import React from "react";
import GrComponentFactory from "./gr_component_factory";

export default GrComponentFactory.createClass({
  displayName: "ProgressBar",

  propTypes: {
    value: React.PropTypes.number.isRequired,
    max: React.PropTypes.number.isRequired,
    width: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
    ]).isRequired,
    progressText: React.PropTypes.string,
  },

  render() {
    const progressBarContainerStyle = { width: this.props.width };
    return(
      <div className="gr-progressBar" aria-label={this.props["aria-label"]}>
        <progress className={this.withBemModifiers("gr-progressBar__progress")}
                  value={this.props.value} max={this.props.max}
                  style={progressBarContainerStyle}
                  role="progressbar"
                  aria-valuetext={this.props.progressText}
                  aria-valuenow={this.props.value}
                  aria-valuemax={this.props.max} />
        {this.props.progressText ?
          <span className="gr-progressBar__text u-defaultType u-marginLeftSmall">{this.props.progressText}</span>
          : this.props.children}
      </div>
    );
  },
});
